<template>
  <section
    id="icons-header"
    class="margin-bottom-3xl"
  >
    <div class="margin-bottom-3xl margin-auto laptop:line-length-xl">
      <h1 class="sr-only">Font Awesome Icons</h1>

      <input-term
        style="--input-placeholder-color: var(--fa-md-gravy)"
        :auto-focus="false"
        :term="term"
        :is-showing-go-button="!!term"
        :label="`Search the v${$releases.active.versionParts.major} Icons`"
        @input="(newTerm) => (term = newTerm)"
        @go="goSearch"
      />
    </div>

    <icons-stats />
  </section>
</template>

<script>
  import IconsStats from './IconsStats'
  import InputTerm from 'app/views/search/components/InputTerm'

  export default {
    name: 'IconsHeader',

    components: {
      IconsStats,
      InputTerm
    },

    data() {
      return {
        term: ''
      }
    },

    methods: {
      goSearch(term) {
        this.$posthog.capture('icons_landing:search_form_submit', {
          search_term: term
        })

        this.$router.push(this.$search({ term }))
      }
    }
  }
</script>
